'use strict';

define(['app', 'jquery', 'siteObj', 'ajaxBasketTemplateTop', 'module'], function (app, $, siteObj, ajaxBasketTemplateTop, module) {

  var productAddToBasket = function productAddToBasket() {
    var component = this;

    var _config = {
      dataAttributes: {
        productIdSelector: 'data-product-id',
        childId: 'data-child-id',
        siteIdSelector: 'data-site-id',
        fromWishlist: 'data-from-wishlist',
        defaultLocaleSelector: 'data-default-locale',
        subsiteCodeSelector: 'data-subsite-code',
        eGiftSelector: 'data-eGift',
        headerBasketSelector: 'header-basket',
        basketItemsSelector: 'basket-items',
        basketQuantityClass: 'header-menu-basket-counter',
        skipAddedToBasket: 'data-skip',
        context: 'data-context',
        wishlistPage: 'data-wishlist-page',
        linkedProduct: 'data-linked-product'
      },
      selectors: {
        productVariations: '[data-variation-container=productVariations]',
        individualVariation: '.individualVariation'
      },
      subscribeChannels: {
        variations: 'productVariations/variationData',
        quantity: 'productQuantityInput/quantityData',
        addedToBasket: 'productAddedToBasket/loadSuccess',
        eGift: 'producteGift/eGift',
        eGiftAddToBasket: 'producteGift/addToBasket'
      },
      stateObject: {
        variationTitle: 'variation'
      },
      soldOutClass: 'productAddToBasket-soldOut'
    };

    var _init = function _init(element, productId) {
      component.element = element;

      if (component.element) {
        component.parentElement = component.element.parentElement.parentElement;
        component.quantity = {
          value: 1,
          max: 99,
          inBasket: 0
        };

        if (component.parentElement) {
          component.allVariations = component.parentElement.querySelectorAll(component.config.selectors.individualVariation);
          component.wishlistPage = component.parentElement.getAttribute(component.config.dataAttributes.wishlistPage);
          component.linkedProduct = component.parentElement.getAttribute(component.config.dataAttributes.linkedProduct);
          component.productId = component.parentElement.getAttribute(component.config.dataAttributes.productIdSelector);
          component.childProductId = component.element.getAttribute(component.config.dataAttributes.productIdSelector);

          if (component.linkedProduct === 'true') {
            if (productId) {
              component.productId = productId;
            }
          }

          component.siteId = component.parentElement.getAttribute(component.config.dataAttributes.siteIdSelector);
          component.defaultLocale = component.parentElement.getAttribute(component.config.dataAttributes.defaultLocaleSelector);
          component.subsiteCode = component.parentElement.getAttribute(component.config.dataAttributes.subsiteCodeSelector);
          component.eGift = component.element.getAttribute(component.config.dataAttributes.eGiftSelector);
          component.skipAddedToBasket = component.element.getAttribute(component.config.dataAttributes.skipAddedToBasket);
          component.context = component.parentElement.getAttribute(component.config.dataAttributes.context);
          component.fromWishlist = component.parentElement.getAttribute(component.config.dataAttributes.fromWishlist);
        }

        if (component.wishlistPage === 'true') {
          component.variationReceived(component.buildVariations());
        } else {
          var variationSubscribe = app.subscribe(component.config.subscribeChannels.variations, component.variationReceived);
          component.checkSubscribeMessages(variationSubscribe, component.variationReceived);
        }

        var quantitySubscribe = app.subscribe(component.config.subscribeChannels.quantity, component.quantityReceived);
        component.checkSubscribeMessages(quantitySubscribe, component.quantityReceived);

        if (component.eGift) {
          app.subscribe(component.config.subscribeChannels.eGift, component.eGiftReceived);
          component.element.addEventListener('click', component.egiftAddToBasket);
        } else if (component.skipAddedToBasket) {
          component.element.addEventListener('click', component.triggerAddStraightToBasket);
        } else {
          component.element.addEventListener('click', component.triggerAddToBasket);
        }
      }

      component.basketHeaderClass = module.config().basketHeaderClass || component.config.dataAttributes.headerBasketSelector;
      component.basketHeaderID = module.config().basketHeaderID || false;
      component.basketItemsContainerClass = module.config().basketItemsContainerClass || component.config.dataAttributes.basketItemsSelector;

      if (component.element.hasAttribute('disabled') && !component.element.classList.contains(component.config.soldOutClass)) {
        component.element.setAttribute('disabled', false);
      }

      return component;
    };

    var _variationReceived = function _variationReceived(_ref) {
      var variationLength = _ref.variationLength,
          variations = _ref.variations;

      component.variationsObject = {
        variationLength: variationLength,
        variations: variations
      };
      if (component.canAdd()) component.enableAddToBasket();else component.disableAddToBasket();
    };

    var _quantityReceived = function _quantityReceived(_ref2) {
      var value = _ref2.value,
          max = _ref2.max,
          inBasket = _ref2.inBasket;

      component.quantity = {
        value: value > 0 && value < 100 ? value : 1,
        max: max,
        inBasket: inBasket
      };
      if (component.canAdd()) component.enableAddToBasket();else component.disableAddToBasket();
    };

    var _canAdd = function _canAdd() {
      var quantity = component.quantity,
          variationsObject = component.variationsObject;

      if (!quantity || !variationsObject) return false;
      if (app.element.hasClass(component.config.soldOutClass, component.element)) return false;
      if (quantity.max && quantity.inBasket && quantity.value + quantity.inBasket > quantity.max) return false;
      if (variationsObject.variationLength !== variationsObject.variations.length) return false;
      if (variationsObject.variations.some(function (v) {
        return !v;
      })) return false;
      return true;
    };

    var _enableAddToBasket = function _enableAddToBasket() {
      component.element.disabled = false;
    };

    var _disableAddToBasket = function _disableAddToBasket() {
      component.element.disabled = true;
    };

    var _checkSubscribeMessages = function _checkSubscribeMessages(subscription, callback) {
      if (subscription.messages.length > 0) {
        var lastItem = subscription.messages.slice(-1)[0];
        callback(lastItem);
      }
    };

    var _triggerAddToBasket = function _triggerAddToBasket() {
      app.publish('addedToBasketModal/hideError', '', false);
      app.publish('productQuickbuy/hideError', '', false);
      app.publish('productQuickbuy/startLoading', '', false);

      if (component.childProductId) {
        app.publish('tracking/record', 'Product | AddToBasket', 'clicked', component.productId, component.childProductId);
      } else {
        app.publish('tracking/record', 'Product | AddToBasket', 'clicked', component.productId);
      }

      component.postAddToBasket(component.querystringifyStateObject(component.createStateObject()));
    };

    var _triggerAddStraightToBasket = function _triggerAddStraightToBasket() {
      var variationsEl = document.querySelector(component.config.selectors.productVariations);
      var childId = variationsEl.getAttribute(component.config.dataAttributes.childId);
      window.location.href = '/my.basket?buylist=' + childId + ':1';
    };

    var _eGiftReceived = function _eGiftReceived(eGiftData) {
      var querystring = component.querystringifyStateObject(component.createStateObject());
      if (querystring && querystring.length > 0 && eGiftData) {
        app.ajax.post({
          url: '/basketinterface.json?' + querystring,
          send: JSON.stringify(eGiftData),
          success: component.addToBasketSuccess,
          error: component.eGiftError
        });
      }
    };

    var _eGiftError = function _eGiftError() {
      app.publish('producteGift/eGiftError', '');
    };

    var _postAddToBasket = function _postAddToBasket(querystring) {
      if (querystring && querystring.length > 0) {
        app.ajax.get({
          url: '/basketinterface.json?' + querystring,
          success: component.addToBasketSuccess,
          error: component.addToBasketError
        });
      }
    };

    var _addToBasketError = function _addToBasketError() {
      app.publish('productQuickbuy/stopLoading', '', false);
      app.publish('productQuickbuy/showError', '', false);
      app.publish('addedToBasketModal/showError', '', false);
    };

    var _addToBasketSuccess = function _addToBasketSuccess(data) {
      var jsonData = JSON.parse(data);
      var modalData = component.getLastAddedItemData(jsonData.simpleBasket, component.createStateObject());
      app.publish('productQuickbuy/hideModal', '', false);
      app.publish('addedToBasketModal/productAdded', modalData, false);
      app.publish('globalBasketItemsCount/updateGlobalBasketItemsCount', modalData.basketTotalItems);
      app.publish('BasketItemAdded', jsonData);
      component.updateBasketIconInHeader(jsonData);
      if (jsonData.simpleBasket.lastAddedItem) {
        var lastAddedItemSku = jsonData.simpleBasket.lastAddedItem.productId;
        if (window.dataLayer.length) {
          window.dataLayer[0].lastAddedItemSku = lastAddedItemSku;
        };
      }
      if (siteObj.fn && siteObj.fn.basket && siteObj.fn.basket.init_basket_update) {
        siteObj.fn.basket.init_basket_update(jsonData);
      }
    };

    var _updateBasketIconInHeader = function _updateBasketIconInHeader(jsonData) {
      var $basket = $(component.basketHeaderID ? '#' + component.basketHeaderID : '.' + component.basketHeaderClass);
      var qty = jsonData.simpleBasket.totalUnits;
      var price = $('<span />').html(jsonData.simpleBasket.totalprice).text();

      // catch page changes which have removed header-basket css class in favour of data selector
      if (!$basket.length) {
        $basket = $('*[data-target="header-basket"]');
      }
      if ($basket.length) {
        $basket.find('.' + component.basketItemsContainerClass).empty().append(ajaxBasketTemplateTop({
          'quantity': qty,
          'basketTitle': siteObj.props.ajaxBasket.titles.basketTitle,
          'basketTotalPrice': price,
          'basketSubTotalPrice': price,
          'basketURL': siteObj.siteBasketURL,
          'viewBasketTitle': siteObj.props.ajaxBasket.titles.basketView,
          'checkoutBtnTitle': siteObj.props.ajaxBasket.titles.basketViewCheckoutBtnTitle,
          'props': siteObj.props
        }));

        // update number of items manually here, as it's not part of the top template
        // when its alternative class is passed via a config parameter
        if (component.config.dataAttributes.basketQuantityClass) {
          var basketQuantityElement = $('.' + component.config.dataAttributes.basketQuantityClass);
          if (basketQuantityElement) {
            basketQuantityElement.text(qty);
            if (qty > 0) {
              basketQuantityElement.removeClass('basketQtyHidden');
              basketQuantityElement.removeClass('zero-items');
            } else {
              basketQuantityElement.addClass('basketQtyHidden');
            }
          }
        }
      }
    };

    var _getLastAddedItemData = function _getLastAddedItemData(simpleBasket) {
      var lastAddedItem = simpleBasket.lastAddedItem;

      var data = {
        productId: lastAddedItem.productId,
        productTitle: lastAddedItem.productTitle,
        productUrl: lastAddedItem.productURL,
        productQuantity: simpleBasket.lastAddedQuantity,
        productQuantityRequested: simpleBasket.lastAddedQuantityRequested,
        productPrice: lastAddedItem.price,
        basketTotalPrice: simpleBasket.totalprice,
        recommendations: simpleBasket.recommendations,
        basketTotalItems: simpleBasket.totalUnits,
        message: simpleBasket.message,
        lastAddedMaxPerOrder: lastAddedItem.maxPerOrder,
        loyaltySchemePoints: simpleBasket.loyaltySchemePoints
      };

      var imageURL = '';
      if (lastAddedItem.productImages && lastAddedItem.productImages.largeproduct) {
        imageURL = lastAddedItem.productImages.largeproduct;
      }

      data.productImageUrl = imageURL;
      return data;
    };

    var _querystringifyStateObject = function _querystringifyStateObject(stateObject) {
      var params = [];
      for (var param in stateObject) {
        if (stateObject.hasOwnProperty(param)) {
          var value = stateObject[param];
          if (param.indexOf('variation') === 0 && param !== 'variationLength') {
            value = param + ':' + value;
          }
          params.push(param + '=' + value);
        }
      }
      return params.join('&');
    };

    var _createStateObject = function _createStateObject() {
      var stateObject = {
        productId: component.productId,
        siteId: component.siteId,
        siteDefaultLocale: component.defaultLocale,
        siteSubsiteCode: component.subsiteCode,
        variationLength: null,
        quantity: null,
        fromWishlist: component.fromWishlist
      };

      if (component.context) {
        stateObject.rctxt = component.context;
      }

      var transformedStateObject = component.transformVariations(stateObject);
      transformedStateObject = component.transformQuantity(transformedStateObject);

      return transformedStateObject;
    };

    var _transformVariations = function _transformVariations(stateObject) {
      var variationsData = component.variationsObject;

      if (variationsData && variationsData.variations) {
        stateObject.variationLength = variationsData.variationLength;

        for (var i = 0; i < variationsData.variations.length; i++) {
          var variationValue = variationsData.variations[i];
          stateObject[component.config.stateObject.variationTitle + (i + 1)] = variationValue;
        }
      }

      return stateObject;
    };

    var _transformQuantity = function _transformQuantity(stateObject) {
      stateObject.quantity = component.quantity ? component.quantity.value : 1;
      return stateObject;
    };

    var _egiftAddToBasket = function _egiftAddToBasket() {
      app.publish(component.config.subscribeChannels.eGiftAddToBasket, '');
    };

    var _buildVariations = function _buildVariations() {
      var variationData = {
        variationLength: component.allVariations.length,
        variations: []
      };

      for (var i = 0; i < component.allVariations.length; i++) {
        var thisVariationDropdown = component.allVariations[i];
        if (thisVariationDropdown.getAttribute('data-variation-id') === '-1') {
          return {
            variationLength: component.allVariations.length,
            variations: []
          };
        }
        variationData.variations.push(thisVariationDropdown.getAttribute('data-variation-id'));
      }

      return variationData;
    };

    component.init = _init;
    component.config = _config;
    component.variationReceived = _variationReceived;
    component.quantityReceived = _quantityReceived;
    component.canAdd = _canAdd;
    component.enableAddToBasket = _enableAddToBasket;
    component.disableAddToBasket = _disableAddToBasket;
    component.checkSubscribeMessages = _checkSubscribeMessages;
    component.triggerAddToBasket = _triggerAddToBasket;
    component.triggerAddStraightToBasket = _triggerAddStraightToBasket;
    component.createStateObject = _createStateObject;
    component.transformVariations = _transformVariations;
    component.transformQuantity = _transformQuantity;
    component.querystringifyStateObject = _querystringifyStateObject;
    component.postAddToBasket = _postAddToBasket;
    component.addToBasketSuccess = _addToBasketSuccess;
    component.addToBasketError = _addToBasketError;
    component.getLastAddedItemData = _getLastAddedItemData;
    component.eGiftReceived = _eGiftReceived;
    component.eGiftError = _eGiftError;
    component.updateBasketIconInHeader = _updateBasketIconInHeader;
    component.egiftAddToBasket = _egiftAddToBasket;
    component.triggerAddStraightToBasket = _triggerAddStraightToBasket;
    component.buildVariations = _buildVariations;
  };

  return productAddToBasket;
});
//# sourceMappingURL=productAddToBasket.js.map
